import { makeSelector } from "../../../testing/index.js";
import { WdioWrapper } from "../../../testing/wdio.js";
import { SelectBaseSelectors } from "../SelectBase/selectBase.selectors.js";
const TestingAttrs = {
  selectButton: "data-select-button"
};
const SelectSelectors = {
  selectButton: makeSelector("Select button", TestingAttrs.selectButton),
  clearButton: SelectBaseSelectors.clearButton,
  applyButton: SelectBaseSelectors.applyButton,
  searchInput: SelectBaseSelectors.searchInput
};
const DsfSelectWrapper = (parentSelector) => WdioWrapper(parentSelector, SelectSelectors);
export {
  DsfSelectWrapper,
  SelectSelectors,
  TestingAttrs
};
